import { Form } from "./Form";
export class UserContacts extends Form {
    constructor(container, events) {
        super(container, events);
        this.events = events;
    }
}
